import React from 'react';
import Loadable from 'react-loadable';
import { RouteComponentProps } from 'react-router';

import BlankLoadingPage from '../../../shared/components/BlankLoadingPage';
import { getQueryFromLocation } from '../../../shared/utils/urls';
import { LoadableWidgetAppointmentDetailPage } from '../../index';

const LoadableSchedulingAppointmentDetailPage = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "schedulingAppointmentDetailPage" */ './SchedulingAppointmentDetailPage'
    ),
  loading: () => <BlankLoadingPage />,
});

type Params = { id: string };

export default function SchedulingAppointmentDetailPage(props: RouteComponentProps<Params>) {
  const { exp_widget_v2 } = getQueryFromLocation(props.location);

  if (exp_widget_v2 == null || exp_widget_v2 === '') {
    return <LoadableWidgetAppointmentDetailPage {...props} />;
  }
  return <LoadableSchedulingAppointmentDetailPage {...props} />;
}
